module.exports = __webpack_public_path__ + "static/img/12.908a675.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/eng/12.png
// module id = BD0z
// module chunks = 0